import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import PopOver from '../../../../Shared/Popover/Popover';
import PopUp from '../../../../Shared/Popup/PopUp';
import { isMobile } from 'react-device-detect';
import { reportAnalytics } from '../../saleJetBlockSlice';
import Checkbox from '../../../../Shared/CheckBox/Checkbox';
import Helper from '../../../../../utilities/helper';
import mobileIconFooter from './images/mobile-icon-footer.svg';
import closeFooterPopup from './images/close-footer-popup.svg';
const SaleFooter = (props) => {
  const [toolTip, setToolTip] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [priceToDisplay, setPriceToDisplay] = useState(props.price);
  const [isAnimationEndMobile, setIsAnimationEndMobile] = useState(false);
  const bottomLinkDisplay = props.bottomLinkDisplay ? true : false;

  const totalProducts = props.selectedProducts?.length;

  useEffect(() => {
    if (props.selectedProducts?.length == 2) {
      if (isAnimationEndMobile) {
        if (props.isNewNumberPageAnimationEnd) {
          setToolTip(true);
        }
      }
      if (props.isNewNumberPageAnimationEnd) {
        setToolTip(true);
      }
    }
  }, [props.isNewNumberPageAnimationEnd, isAnimationEndMobile]);

  useEffect(() => {
    if (props.price && props.price.toString().indexOf('.') != -1) {
      setPriceToDisplay(props.price.toFixed(2));
    } else if (props.price) {
      setPriceToDisplay(props.price);
    }
  }, [props.price]);

  if (!props.isDisplayFooter) {
    return null;
  }

  const closeTooltip = (e) => {
    e.stopPropagation();
    setToolTip(false);
  };

  const openPopUp = () => {
    if (props.selectedProducts?.length > 0) {
      setToolTip(false);
      setShowPopUp(true);
      props.reportAnalytics({
        eventCategory: 'cellular_newsale_process',
        eventAction: props.flowType == 'existsCustomer' ? 'visibility_8' : 'visibility_19',
        eventLabel: props.selectedProducts[0]?.name,
      });
    }
  };

  const closePopUp = () => {
    setShowPopUp(false);
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: props.flowType == 'existsCustomer' ? 'click_19' : 'click_40',
      eventLabel: props.selectedProducts[0]?.name,
    });
  };

  const saveToImage = async () => {
    const html2canvas = require('html2canvas');
    const canvas = await html2canvas(document.querySelector('.sale-page-content'));
    canvas.style.display = 'none';
    document.body.appendChild(canvas);
    const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const a = document.createElement('a');
    a.setAttribute('download', `info.png`);
    a.setAttribute('href', image);
    a.click();
    document.body.removeChild(canvas);
  };

  const saveToCalendar = () => {
    const { saveAs } = require('file-saver');
    const ics = require('ics');

    const event = {
      start: [2018, 5, 30, 6, 30],
      duration: { days: 1 },
      title: `ביקור טכנאי ${window.Config.brand_Name_HE}`,
      location: `${props.selectedAddress?.cityName} , ${props.selectedAddress?.streetName}  ${props.selectedAddress?.home}`,
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
      //   url: 'http://www.bolderboulder.com/',
      // geo: { lat: 40.0095, lon: 105.2669 },
      // categories: ['10k races', 'Memorial Day Weekend', 'Boulder CO'],
      //  organizer: { name: 'Admin', email: 'Race@BolderBOULDER.com' },
      //  attendees: [
      //   { name: 'Adam Gibbons', email: 'adam@example.com', rsvp: true, partstat: 'ACCEPTED', role: 'REQ-PARTICIPANT' },
      //   { name: 'Brittany Seaton', email: 'brittany@example2.org', dir: 'https://linkedin.com/in/brittanyseaton', role: 'OPT-PARTICIPANT' }
      // ]
    };

    ics.createEvent(event, (error, value) => {
      if (error) {
        console.log('we get error' + error);
        return;
      }
      var file = new File([value], 'CellcomReminder.ics', { type: 'text/calendar' });
      console.log('the file is: ' + file);
      console.log('the event is: ' + event);
      console.log('the value is: ' + value);
      saveAs(file);
    });
  };

  function openTermsInNewTab(e) {
    e.preventDefault();
    window.open(props.termsCheckbox.termsLink, '_blank').focus();
  }

  function openTermsOfServiceUrl(e){
    e.preventDefault();
    window.open(props.termsOfServiceCheckbox.termsLink, '_blank').focus();
  }

  return (
    <>
      <footer className={`sale-jet-footer ${props.className === 'cancelFixed' ? 'cancelFixed' : ''} ${props.bottomLinkDisplay ? 'bottomLinkDisplay' : ''}`}>
        <div className={`sale-footer-wrapper ${isMobile ? 'slideAnimation' : ''}`} onAnimationEnd={() => setIsAnimationEndMobile(true)}>
          {props.price ? (
            <>
              {totalProducts && totalProducts > 0 && (
                <>
                  <div className='mobile-icon-wrapper'>
                    <div className='mobile-icon' style={{backgroundImage:mobileIconFooter.bg()}}  id='device_count' aria-label='products count' onClick={() => openPopUp()}>
                      {totalProducts}
                    </div>
                    <PopOver
                      className='mobile-icon-popover'
                      placement='top'
                      text='בכל שלב, אפשר להקליק ולראות פה את פירוט ההזמנה'
                      target='device_count'
                      isOpen={toolTip}
                      closePopover={(e) => closeTooltip(e)}
                    />
                  </div>
                </>
              )}
              <div className='price-wrapper'>
                <div className='price-and-text clearfix'>
                  <div className='price'> ₪{priceToDisplay} </div>
                  <div className='price-text'> {props.priceText} </div>
                </div>
                {props.totalPriceOneTime > 0 && <div className='price-sub-text'> + חיוב חד פעמי {props.totalPriceOneTime} ₪ </div>}
              </div>
            </>
          ) : null}

          {props.termsCheckbox && (
            <Checkbox
              id='terms-checkbox'
              onCheck={props.termsCheckbox.onClickCheckbox}
              onUncheck={props.termsCheckbox.onClickCheckbox}
              checked={props.termsCheckbox.isChecked}>
              אני מאשר\ת את{' '}
              <a
                href='#'
                onClick={(e) => {
                  openTermsInNewTab(e);
                }}>
                {' '}
                תנאי השימוש ועיקרי ההסכם
              </a>
            </Checkbox>
          )}

          {props.termsOfServiceCheckbox?.termsLink &&  (
            <div className='terms-of-service-checkbox-wrapper'>
            <Checkbox
              id='terms-of-service-checkbox'
              checked={props.termsOfServiceCheckbox.isChecked}
              onChange={() => props.termsOfServiceCheckbox.onClickCheckbox(!props.termsOfServiceCheckbox.isChecked)}>
              קראתי ואני מסכים{' '}
              <a
                href='#'
                onClick={(e) => {
                  openTermsOfServiceUrl(e);
                }}>
                {' '}
                לתנאי השימוש
              </a>
            </Checkbox>
            </div>

          )}

          {props.marketingCheckbox && (
            <Checkbox
              id='marketing-checkbox'
              onCheck={props.marketingCheckbox.onClickCheckbox}
              onUncheck={props.marketingCheckbox.onClickCheckbox}
              checked={props.marketingCheckbox.isChecked}>
              הפרטים שמסרת (כולל מספרי טלפון וכתובות דוא"ל) ישמשו למשלוח דיוור (לרבות דיוור ישיר) בנושאים שונים ובכלל זאת דברי פרסומות
              לשירותי {window.Config.brand_Name_HE}, אף אם לא תסמן כי הנך מעונין בקבלת מידע שיווקי, וזאת כל עוד לא תסרב לקבלם כמפורט בהסכם התנאים הכלליים ובמדיניות
              הפרטיות
            </Checkbox>
          )}

          {props.isDisplaySaveAsPictureBtn || props.isDisplaySaveToCalendar && (
            <div className='success-page-buttons'>
              {props.isDisplaySaveAsPictureBtn &&
              (<button className='save-to-image' onClick={() => Helper.saveToImage('.sale-page-content')}>
                שמירה כתמונה
              </button>)}

              {props.isDisplaySaveToCalendar &&
              (<button className='save-to-calendar' onClick={() => Helper.saveToCalendar()}>
                  הוספת תזכורת ליומן
                </button>
              )}
            </div>
          )}

          {props.errorText && <div className='error-text'>{props.errorText}</div>}

          <div className={`${props.price ? 'btn-left' : 'btn-center'} ${props.disableButton ? 'disableFooterButton' : ''}`}>
            {props.isWhiteButton ?
            <button className='white-btn' onClick={() => props.onclick()}>{props.btnText}</button>
            :
              <BtnSubmit
                isBusiness={false}
                text={props.btnText}
                onclick={props.onclick}
                formid={props.formid}
                isDisplayArrows={props.isDisplayArrows}
                isDisplayWhatsAppIcon={props.isDisplayWhatsAppIcon}
                disabled={!!props.disableButton}
              />
            }
          </div>

          {
            props.bottomLink &&
            <div className='whatsapp-link-wrapper'>
              <a href='#' onClick={props.bottomLink.onclick}>{props.bottomLink.text}</a>
            </div>
          }

        </div>
      </footer>

      {props.selectedProducts && props.selectedProducts.length > 0 && (
        <PopUp showPopUp={showPopUp} onClose={() => closePopUp()} className='all-products-popup'>
          <h2>מה היה לנו?</h2>
          <p>סיכום הזמנתך עד כה</p>
          {props.selectedProducts.map(function (product, index) {
            const selectedPhone = product.isExistPhone ? product.existPhone : product.newPhone;

            const phone = selectedPhone ? selectedPhone.slice(0, 3) + '-' + selectedPhone.slice(3, selectedPhone.length) : '';
            return (
              <div className='products-wrapper' key={index}>
                <div className='phone-wrapper'>
                  <div className='phone'>
                    קו {index + 1} - {phone}
                  </div>
                  <div className='btn'>
                    <button className='delete-product test' onClick={() => props.removeProduct(index)} style={{backgroundImage:closeFooterPopup.bg()}}></button>
                  </div>
                </div>
                <div className='product-name'>
                  <div className='text'>{product.name}</div>
                  <div className='price'>{product.additionalPrice} ₪ </div>
                </div>
                {product.selectedVasList?.map(function (vas, i) {
                  return (
                    <div className='product-name'>
                      <div className='text'>{vas.title}</div>
                      <div className='price'>{vas.price == '' || vas.price == '0' ? 'כלול בחבילה' : vas.price + ' ₪'} </div>
                    </div>
                  );
                })}
                <div className='product-name'>
                  <div className='text'>{product.isEsim ? 'eSim דיגיטלי בעלות חד פעמית' : 'כרטיס SIM בעלות חד פעמית'}</div>
                  <div className='price'>{product.oneTimeFee} ₪ </div>
                </div>
                {product.isPrettyNum && (
                  <div className='product-name'>
                    <div className='text'>{product.prettyNumberName}</div>
                    <div className='price'>
                      {product.prettyNumberPrice == '' || product.prettyNumberPrice == '0' ? (
                        'ללא עלות'
                      ) : (
                        <>{product.prettyNumberPrice} ₪</>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          <div className='footer-popup'>
            <div className='total-price'>
              <span className='text'>סה"כ חיוב חודשי</span>
              <span className='price'>{props.price} ₪ </span>
            </div>
            <div className='total-price'>
              <span className='text'>סה"כ עלות חד פעמית</span>
              <span className='price'>{props.totalPriceOneTime} ₪ </span>
            </div>
          </div>
        </PopUp>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    flowType: state.saleBlock.flowType,
    selectedAddress: state.saleJetBlock.addressPage.selectedAddress,
  };
};

const mapDispatchToProps = {
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleFooter);
